// COMMON TEXT
export const map_travel_link = {
  EN: "Map",
  PL: "Mapa",
  SP: "Mapa",
};

const rsvp_common = {
  EN: "RSVP",
  PL: "Potwierdzenie przybycia",
  SP: "RSVP",
};

// NAV TEXT
export const date_header = {
  EN: "23.AUG.2025",
  PL: "23.VIII.2025",
  SP: "01.03.2025",
};

export const date_header_mobile = {
  EN: "23.AUG.25",
  PL: "23.VIII.25",
  SP: "01.03.25",
};

export const home_header_mobile_only = {
  EN: "Wedding",
  PL: "Wesele",
  SP: "El Casamiento",
};

export const story_header = {
  EN: "Our Story",
  PL: "Nasza historia",
  SP: "Nuestra Historia",
};

export const travel_header = {
  EN: "Travel & Stay",
  PL: "Podróż i pobyt",
  SP: "Viaje y Estancia",
};

export const registry_header = {
  EN: "Registry",
  PL: "Lista prezentów",
  SP: "Registro",
};

export const blog_header = {
  EN: "Mayra's Blog",
  PL: "Blog Mayry",
  SP: "Blog de Mayra",
};

export const faq_header = {
  EN: "FAQ",
  PL: "Pytania do nas",
  SP: "Preguntas Frecuentes",
};

export const rsvp_header = rsvp_common;

// WHATSAPP TEXT
export const whatsapp_header = {
  EN: "Looking to stay up to date?",
  PL: "Chcesz być na bieżąco?",
  SP: "",
};

export const whatsapp_text = {
  EN: "Join our WhatsApp group for announcements.",
  PL: "Dołącz do naszej grupy na WhatsAppie, aby otrzymywać ogłoszenia i ważne informacje.",
  SP: "",
};

export const whatsapp_button = {
  EN: "Join Our WhatsApp",
  PL: "Dołącz do nas",
  SP: "",
};

// TRAVEL&STAY TEXT
export const travel_title = {
  EN: "Travel",
  PL: "Podróż",
  SP: "",
};

export const travel_subtitle = {
  EN: "Niepołomice, Poland",
  PL: "Niepołomice",
  SP: "",
};

export const travel_directions_title = {
  EN: "Directions",
  PL: "Wskazówki",
  SP: "",
};

export const travel_directions_text = {
  EN: "Fly into Warsaw",
  PL: "Przylot do Warszawy",
  SP: "",
};

export const travel_directions_text_2 = {
  EN: "Fly into Kraków",
  PL: "Przylot do Krakowa",
  SP: "",
};

export const travel_directions_text_body_part_1 = {
  EN: "It is often more affordable to fly into Chopin Airport. From there, you can take a high-speed train with ",
  PL: "Często bardziej opłaca się przylecieć na lotnisko Chopina. Stamtąd można wziąć pociąg ekspresowy z ",
  SP: "",
};

export const travel_directions_text_body_part_2 = {
  EN: " to Kraków. Tickets typically range from 70 to 170 PLN (approximately 17 to 42 USD), and the journey takes just over two hours.",
  PL: " do Krakowa. Bilety zazwyczaj kosztują od 70 do 170 PLN, a podróż trwa nieco ponad dwie godziny.",
  SP: "",
};

export const travel_directions_text_body_3 = {
  EN: "While flights to this location are generally more expensive, Niepołomice is conveniently located just 30 minutes away by car.",
  PL: "Podczas gdy loty do tej lokalizacji są zazwyczaj droższe, Niepołomice znajdują się zaledwie 30 minut jazdy samochodem.",
  SP: "",
};

export const stay_title = {
  EN: "Stay",
  PL: "Pobyt",
  SP: "",
};

export const stay_subtitle = {
  EN: "Hotel Novum",
  PL: "Hotel Novum",
  SP: "",
};

export const stay_text = {
  EN: "We have reserved rooms for our guests at Hotel Novum, located just 500 meters (1/3 mile) from the castle for your convenience.",
  PL: "Zarezerwowaliśmy pokoje dla naszych gości w Hotelu Novum, który znajduje się zaledwie 500 metrów od zamku.",
  SP: "",
};

// CAR RENTAL TEXT
export const car_rental_title = {
  EN: "Car Rental",
  PL: "Wynajem samochodu",
  SP: "Alquiler de coche",
};

// MAP TEXT
export const warsaw_airport_text = {
  EN: "Warsaw Chopin Airport",
  PL: "Lotnisko Chopina w Warszawie",
  SP: "",
};

export const krakow_airport_text = {
  EN: "Kraków John Paul II Airport",
  PL: "Kraków Airport im. Jana Pawła II",
  SP: "",
};

export const loading_text = {
  EN: "Loading...",
  PL: "Ładowanie...",
  SP: "",
};

// RSVP FORM TEXT
export const rsvp_title = rsvp_common;

export const rsvp_subtitle = {
  EN: "Please enter your first and last name",
  PL: "Proszę wpisać swoje imię i nazwisko",
  SP: "",
};

export const continue_button = {
  EN: "Continue",
  PL: "Kontynuuj",
  SP: "",
};

export const rsvp_name_not_found = {
  EN: "Name not found. Please make sure it matches the invitation exactly or please contact Mayra or Szymon.",
  PL: "Imię nie zostało znalezione. Proszę upewnić się, że zgadza się z zaproszeniem lub skontaktować się z Mayrą lub Szymonem.",
  SP: "",
};

export const rsvp_thank_you_top = {
  EN: "Thank you for your RSVP!",
  PL: "Dziękujemy!",
  SP: "",
};

export const rsvp_thank_you_bottom = {
  EN: "Your entry has been recorded.",
  PL: "Twoje zgłoszenie zostało zapisane.",
  SP: "",
};

// DETAILS BANNER TEXT
export const first_banner_text = {
  EN: "Wedding Day",
  PL: "Dzień Wesela",
  SP: "Ceremonia",
};

export const second_banner_text = {
  EN: "Poprawiny",
  PL: "Poprawiny",
  SP: "Recepción",
};

export const first_banner_subtext = {
  EN: "August 23",
  PL: "23 sierpnia 2025",
  SP: "Te Invitamos",
};

export const second_banner_subtext = {
  EN: "August 24",
  PL: "24 sierpnia 2025",
  SP: "¡Te esperamos!",
};

export const optional_text = {
  EN: "(Optional)",
  PL: "(Opcjonalne)",
  SP: "(Opcional)",
};

export const poprawiny_title = {
  EN: "What is Poprawiny?",
  PL: "Czym są poprawiny?",
  SP: "",
};

export const poprawiny_text = {
  EN: "Poprawiny (pronounced poh-prah-vee-nee) is a cherished Polish tradition held on the day after the wedding. The word itself comes from poprawić, meaning “to improve” — a fitting name for this relaxed, optional luncheon where the newlyweds spend more time with their guests. Originally meant to ensure guests were safely sent off, it’s now a warm and informal continuation, often featuring homemade dishes like rosół (Polish chicken soup) and a come-as-you-are vibe. While attendance is completely optional, we’d love to know if you’ll be joining us — please kindly RSVP!",
  PL: "Poprawiny to piękna polska tradycja odbywająca się w drugim dniu uroczystości ślubnych. Jest to nieformalne przyjęcie, podczas którego nowożeńcy mogą spędzić więcej czasu ze swoimi gośćmi. Tradycja ta sięga wielu wieków wstecz i pierwotnie miała na celu zapewnienie, że goście bezpiecznie opuszczą miejsce uroczystości po zakończeniu świętowania. Choć udział w poprawinach jest całkowicie dobrowolny, będzie nam niezmiernie miło, jeśli do nas dołączycie — uprzejmie prosimy o potwierdzenie przybycia.",
  SP: "",
};

// RSVP INDIVIDUAL GUEST CONTAINER TEXT
export const rsvp_is_attending_male = {
  EN: " is marked as attending.",
  PL: " został zgłoszony jako obecny.",
  SP: "",
};

export const rsvp_is_attending_female = {
  EN: " is marked as attending.",
  PL: " została zgłoszona jako obecna.",
  SP: "",
};

export const rsvp_is_not_attending_male = {
  EN: " is marked as not attending.",
  PL: " został zgłoszony jako nieobecny.",
  SP: "",
};

export const rsvp_is_not_attending_female = {
  EN: " is marked as not attending.",
  PL: " została zgłoszona jako nieobecna.",
  SP: "",
};

export const rsvp_courtesy_text = {
  EN: "Feel free to update below.",
  PL: "Jeśli coś się zmieni, proszę daj nam znać.",
  SP: "",
};

export const rsvp_able_to_attend = {
  EN: "Is ",
  PL: "Czy potwierdzasz swoją obecność ",
  SP: "",
};
export const rsvp_able_to_attend_2 = {
  EN: " Able to Attend?",
  PL: "?",
  SP: "",
};

export const rsvp_will_attend = {
  EN: "Yes, Will Attend",
  PL: "Tak, potwierdzam obecność",
  SP: "",
};

export const rsvp_declines = {
  EN: "No, Declines With Regret",
  PL: "Nie, z przykrością odmawiam",
  SP: "",
};

export const poprawiny_rspv_text = {
  EN: "We'll see ",
  PL: "",
  SP: "",
};

export const poprawiny_rspv_text_2 = {
  EN: " at Poprawiny as well!",
  PL: " również bedzie na poprawinach!",
  SP: "",
};

export const poprawiny_rsvp_question = {
  EN: "Is ",
  PL: "Czy będziesz też z nami na poprawinach 24 sierpnia ",
  SP: "",
};

export const poprawiny_rsvp_question_2 = {
  EN: " also able to attend Poprawiny on August 24?",
  PL: "?",
  SP: "",
};

export const poprawiny_not_attending_text_male = {
  EN: " is only attending the first day.",
  PL: " będzie obecny tylko pierwszego dnia.",
  SP: "",
};

export const poprawiny_not_attending_text_female = {
  EN: " is only attending the first day.",
  PL: " będzie obecna tylko pierwszego dnia.",
  SP: "",
};

export const dietary_restrictions_text = {
  EN: "Any Dietary Restrictions?",
  PL: "Jakieś Ograniczenia Dietetyczne?",
  SP: "",
};

export const dietary_restrictions_subtext = {
  EN: "(None, Vegetarian, Other)",
  PL: "(brak, wegetariańskie, inne)",
  SP: "",
};

export const song_request_text_male = {
  EN: "Song Request",
  PL: "Jaką piosenkę chciałbyś usłyszeć na naszym weselu?",
  SP: "",
};

export const song_request_text_female = {
  EN: "Song Request",
  PL: "Jaką piosenkę chciałabyś usłyszeć na naszym weselu?",
  SP: "",
};

export const invited_guests_header = {
  EN: "Invited Guests",
  PL: "Zaproszeni Goście",
  SP: "",
};

export const rsvp_submit_button = {
  EN: "Submit RSVP",
  PL: "Potwierdź przybycie",
  SP: "",
};

// OUR STORY TEXT
export const our_story_title = {
  EN: "Our Story",
  PL: "Jak to się wszystko zaczęło...",
  SP: "Nuestra Historia",
};

export const our_story_gallery_title = {
  EN: "Our Engagement Trip",
  PL: "Z naszej podróży zaręczynowej",
  SP: "Nuestro Viaje de Compromiso",
};

export const our_story_paragraph_1 = {
  EN: "Mayra and Szymon met through a volleyball league and, by some miracle, ended up on the same team. Despite Szymon’s unruly hair (if you know, you know), Mayra was impressed by his volleyball skills right away. A couple of months into knowing each other, Mayra was deep into her DIY phase, and Szymon decided to help her build a TV stand. He made it seem like he had all the right tools, but in reality, he’d gone to Home Depot and bought power tools just for the task. The project brought them much closer together, and the rest is history.",
  PL: `Mayra i Szymon poznali się w stanie Michigan w lidze siatkarskiej, i jakimś cudem albo zrządzeniem losu, znaleźli się w tym samym zespole. Pomimo niesfornych włosów Szymona (ci co go znają, wiedzą, o czym mowa), Mayra była pod wrażeniem jego umiejętności gry w siatkówkę. Parę miesięcy później, kiedy Mayra była w fazie projektów "zrób to sama" i potrzebowała pomocy przy zbudowaniu szafki pod telewizor, tu nieoczekiwanie pojawił się Szymon. Wyglądał na takiego, który wie, co robi i posiada wszystkie niezbędne narzędzia. Tak naprawdę pojechał do sklepu "Home Depot" (to taki odpowiednik polskiego "Obi") i kupił narzędzia do zrobienia szafki. Wspólna praca nad tym projektem zbliżyła ich bardzo do siebie, a resztę historii wszyscy znają.`,
  SP: "Mayra y Szymon se conocieron a través de una liga de voleibol y, por un milagro, terminaron en el mismo equipo. A pesar de que el cabello de Szymon parecía un campo de batalla, Mayra quedó fascinada al instante por sus habilidades en el voleibol. Un par de meses después, cuando Mayra estaba en plena onda de bricolaje, Szymon decidió ayudarla a armar un mueble para el televisor. Él parecía tener todas las herramientas necesarias, pero la realidad es que se había mandado a Home Depot a comprar un montón de herramientas eléctricas solo para ese proyecto. ¡Qué genio! El trabajo en equipo los unió aún más, y el resto, como dicen, es historia.",
};

export const our_story_paragraph_2 = {
  EN: "In April of the following year, Szymon bought a house, and both Luna and Mayra moved in. Together, the three of them ventured to Chicago and eventually made their way to Jersey City.",
  PL: "W kwietniu następnego roku Szymon kupił dom w Michigan i Mayra oraz Luna wprowadziły się. Później wspólnie we trójkę przenieśli się do Chicago, żeby koniec końców znaleźć się w Jersey City.",
  SP: "En abril del año siguiente, Szymon compró una casa, y tanto Luna como Mayra se mudaron con él. Juntos, los tres se lanzaron a la aventura en Chicago y, con el tiempo, se establecieron en Jersey City.",
};

export const our_story_paragraph_3 = {
  EN: "Mayra says one of the things she loves most about Szymon is how great of a partner he is, both at home and in life. They’ve developed an unspoken way of gauging each other’s workloads and making life easier for one another, without needing to ask.",
  PL: "Mayra najbardziej kocha w Szymonie to, że jest wspaniałym partnerem w domu, jak i w życiu. Wypracowali sobie z czasem umiejętność porozumiewania się bez słów i pomagania sobie nawzajem w codzienności, bez zadawania zbędnych pytań.",
  SP: "Mayra dice que lo que más le gusta de Szymon es lo increíble compañero que es, tanto en la casa como en la vida. Han desarrollado una especie de telepatía para medir las cargas de trabajo del otro y hacer que todo sea más fácil sin necesidad de pedir nada. ¡Pura armonía!",
};

export const our_story_paragraph_4 = {
  EN: "Szymon says Mayra is one of the most considerate people he’s ever met. She always puts him and her loved ones first, listens to everyone, and remembers every little detail they share. It’s hard to beat her in a gift-giving competition.",
  PL: "Według Szymona Mayra jest jedną z najbardziej troskliwych i wrażliwych osób, jakie kiedykolwiek poznał w swoim życiu. Zawsze stawia jego i swoich bliskich na pierwszym miejscu, potrafi wysłuchać i pamięta najdrobniejsze szczegóły. Trudno pokonać ją w konkursie na najlepszy prezent.",
  SP: "Por su parte, Szymon dice que Mayra es una de las personas más consideradas que ha conocido. Siempre pone a él y a sus seres queridos en primer lugar, escucha a todos y nunca olvida un solo detalle que le comparten. ¡Es imposible ganarle en un concurso de regalos!",
};

export const our_story_paragraph_5 = {
  EN: "The pair is excited to start this new chapter together and see where life takes them.",
  PL: "Obydwoje z radością rozpoczynają nowe wspólne życie i zobaczą, dokąd ono ich zaprowadzi.",
  SP: "La pareja está súper emocionada de empezar este nuevo capítulo y ver qué sorpresas les trae la vida.",
};

// WEDDING DETAILS TEXT
export const first_banner_title = {
  EN: "Ceremony & Reception",
  PL: "Kiedy i gdzie",
  SP: "1 de Marzo",
};

export const first_banner_time = {
  EN: "16:30",
  PL: "godzina 16:30",
  SP: "18:30",
};

export const first_banner_address_top = {
  EN: "Zamek Królewski w Niepołomicach",
  PL: "Zamek Królewski w Niepołomicach",
  SP: "Capilla Stella Montis",
};

export const first_banner_address_mid = {
  EN: "Zamkowa 2, 32-005",
  PL: "ul. Zamkowa 2",
  SP: "Villa Serranita",
};

export const first_banner_address_bot = {
  EN: "Niepołomice, Poland",
  PL: "32-005 Niepołomice",
  SP: "Argentina",
};

export const first_banner_map = {
  EN: "https://maps.app.goo.gl/CW57ZFBxmS2huGWp9",
  PL: "https://maps.app.goo.gl/CW57ZFBxmS2huGWp9",
  SP: "https://maps.app.goo.gl/mGDbtN5x7L8sUroq5",
};

export const first_banner_attire = {
  EN: "Attire: Black Tie Optional",
  PL: "None",
  SP: "Atuendo: Corbata Negra Opcional",
};

export const second_banner_title = {
  EN: "Grill & Drinks",
  PL: "Przepitki & przekąski",
  SP: "1 de Marzo",
};

export const second_banner_time = {
  EN: "11:00",
  PL: "godzina 11:00",
  SP: "21:00",
};

export const second_banner_map = {
  EN: "https://maps.app.goo.gl/CW57ZFBxmS2huGWp9",
  PL: "https://maps.app.goo.gl/CW57ZFBxmS2huGWp9",
  SP: "https://maps.app.goo.gl/VfxasfaxYwMRRFXP9",
};

export const second_banner_address_top = {
  EN: "Zamek Królewski w Niepołomicach",
  PL: "Zamek Królewski w Niepołomicach",
  SP: "La Qunita Casona",
};

export const second_banner_address_mid = {
  EN: "Zamkowa 2, 32-005",
  PL: "ul. Zamkowa 2",
  SP: "Celso Barrios 3490",
};

export const second_banner_address_bot = {
  EN: "Niepołomice, Poland",
  PL: "32-005 Niepołomice",
  SP: "Córdoba, Argentina",
};

export const second_banner_attire = {
  EN: "Attire: Smart Casual",
  PL: "None",
  SP: "Código de Vestimenta Formal",
};

// JOIN US BANNER TEXT
export const join_us_title = {
  EN: "Join Us",
  PL: "Dołącz do nas",
  SP: "Únete a nosotros",
};

export const join_us_subtext = {
  EN: "We hope you can make it!",
  PL: "Mamy nadzieję, że bedziesz!",
  SP: "¡Esperamos que puedas hacerlo!",
};

export const join_us_button = rsvp_common;

// FAQ TEXT
const argentina_faq = [
  {
    question:
      "¿Puedo traer invitados adicionales o niños que no estén en la invitación?",
    answer:
      "Lamentablemente, no es posible, ya que hemos contratado un número fijo de platos. Solo las personas mencionadas al final de la invitación digital pueden asistir.",
  },
  {
    question: "¿Cuánto cuesta la tarjeta?",
    answer:
      "Hemos decidido cubrir el costo del cubierto para nuestros invitados.",
  },
  {
    question: "¿A qué hora tendría que llegar?",
    answer:
      "Los novios harán su entrada a las 21:15 horas. Nos encantaría que estuvieras ahí para darles la bienvenida. Entonces por favor, calcule llegar a las 21:00 y procurá no llegar demasiado temprano tampoco.",
  },
  {
    question: "¿Cómo me visto?",
    answer:
      "Nos gustaría que aprovecharas esta oportunidad para vestirte bonito. Un vestido o conjunto lindo para las mujeres y un traje o camisa de botones para los hombres por ejemplo.",
  },
  {
    question: "¿Qué más debo llevar?",
    answer:
      "¡Planeamos bailar toda la noche! Si vas a usar tacones incómodos, te recomendamos traer un par de sandalias para cambiarte. Además, mantén un ojo en el clima por si necesitas llevar un suéter o un paraguas.",
  },
  {
    question: "¿Qué hago si tengo alergias?",
    answer:
      "Por favor, avísale a Mayra o Analia lo antes posible sobre tus restricciones alimentarias para poder tomar las precauciones necesarias.",
  },
  {
    question: "¿Qué les puedo regalar?",
    answer:
      "Su presencia es el mejor regalo que podemos recibir! Estamos muy agradecidos de poder celebrar con nuestros amigos y familiares. No obstante, si deseas hacernos un regalo, te pedimos que tengas en cuenta que estamos viajando internacionalmente y no podremos llevar objetos grandes. Lo más fácil sería algo que podamos disfrutar mientras estamos en Argentina, como un certificado para algún restaurante, o tu vino favorito para que podamos probarlo. ¡Igual, no te preocupes por los regalos!",
  },
  {
    question: "¿Por qué no fui invitado a la misa/ceremonia?",
    answer:
      "Tendremos una misa íntima de 'bendición de los anillos' en La Capilla Stella Montis a las 18:30 horas de ese día. Debido a la distancia con el salón  de la fiesta, decidimos invitar únicamente a los familiares más cercanos y amigos íntimos. Si deseás acompañarnos, serás más que bienvenido!",
  },
];

const poland_faq_english = [
  {
    question: "What time is the wedding?",
    answer:
      "Please plan to arrive no later than 4:15 PM, as the ceremony will begin promptly at 4:30 PM. We can’t wait to celebrate with you!",
  },
  {
    question: "What should I wear?",
    answer:
      "We would love for you to use this special occasion as an opportunity to dress up! The dress code is formal, so tuxedos and gowns are warmly welcomed, as are suits and dresses. Please avoid wearing white or anything that might appear white in photographs, as this is traditionally reserved for the bride.",
  },
  {
    question: "Is there transportation to/from the venue?",
    answer:
      "Yes, we’re happy to provide transportation from the hotel to the venue and back to the hotel at the end of the night. We want everyone to enjoy the celebration without worrying about getting there or back!",
  },
  {
    question:
      "Can I bring an additional guest or child who was not listed on the invitation?",
    answer:
      "We truly appreciate your excitement to celebrate with us! However, as we have made arrangements for a specific number of guests, we kindly ask that only those named on the invitation attend. We appreciate your understanding.",
  },
  {
    question: "Do I need to reserve a room at Hotel Novum?",
    answer:
      "No, you do not need to reserve a room at Hotel Novum. We've booked a room for you for the night of the wedding, August 23rd, so you can simply check in upon arrival. The hotel is conveniently located just 500 meters (1/3 mile) from the castle.",
  },
  {
    question: "What is Poprawiny?",
    answer:
      "Poprawiny is a lovely Polish tradition held on the second day of the wedding celebration. It's an optional luncheon where the newlyweds spend more time with their guests. The tradition goes back many centuries and was originally meant to ensure that guests were safely sent off after the festivities.",
  },
  {
    question: "What should we gift?",
    answer:
      "Your presence is the greatest gift we could ask for, especially considering how many of you have traveled such great distances to be with us! If you would still like to give a gift, please note that we will be flying home and cannot take large items. Feel free to send gifts to our home, or you can choose something from our registry for your convenience.",
  },
  {
    question: "Do I need a special permit to drive in Poland?",
    answer:
      "Yes, visitors with non-EU driver's licenses will need an International Driving Permit (IDP) to rent and drive a car in Poland. If you're coming from the US, you can obtain an IDP from AAA before your trip.",
  },
];

const poland_faq_polish = [
  {
    question: "O której godzinie odbędzie się ceremonia ślubna?",
    answer:
      "Prosimy o przybycie najpóźniej o godzinie 16:15, ponieważ ceremonia rozpocznie się o 16:30. Nie możemy się doczekać, aby świętować z Wami ten wyjątkowy dzień!",
  },
  {
    question: "Jaki strój będzie odpowiedni?",
    answer:
      "Chcielibyśmy, abyście wykorzystali tę wyjątkową okazję do eleganckiego ubioru! Prosimy jednak unikać koloru białego lub ubrań, które mogą wyglądać na białe na zdjęciach, gdyż jest to kolor tradycyjnie zarezerwowany dla panny młodej.",
  },
  {
    question:
      "Czy zapewniony jest transport na miejsce uroczystości i z powrotem?",
    answer:
      "Tak, z przyjemnością zapewniamy transport z hotelu do miejsca ceremonii i z powrotem do hotelu po zakończeniu imprezy. Chcemy, abyście mogli cieszyć się świętowaniem, nie martwiąc o transport!",
  },
  {
    question: "Czy mogę zabrać dodatkowego gościa lub dziecko?",
    answer:
      "Bardzo cieszymy się, że chcecie świętować z nami! Niemniej jednak, ponieważ zaplanowaliśmy określoną liczbę gości, uprzejmie prosimy, aby na uroczystości pojawiły się tylko osoby wymienione na zaproszeniu. Dziękujemy za zrozumienie.",
  },
  {
    question: "Jaki prezent będzie odpowiedni?",
    answer:
      "Wasza obecność to dla nas najpiękniejszy prezent, zwłaszcza że wielu z Was pokonało dużą odległość, aby być z nami! Jeśli mimo to chcielibyście podarować nam prezent, prosimy pamiętać, że będziemy podróżować samolotem i nie będziemy w stanie zabrać dużych przedmiotów. Jeśli chcecie, prezenty można wysłać na nasz adres lub skorzystać z naszej listy prezentów.",
  },
  {
    question: "Czy muszę rezerwować pokój w Hotelu Novum?",
    answer:
      "Nie, nie muszą Państwo rezerwować pokoju w Hotelu Novum. Zarezerwowaliśmy dla Państwa pokój na noc wesela (23 sierpnia) dlatego wystarczy zameldować się po przyjeździe. Hotel znajduje się w dogodnej lokalizacji, zaledwie 500 metrów od zamku.",
  },
];

export const faq = {
  EN: poland_faq_english,
  PL: poland_faq_polish,
  SP: argentina_faq,
};

export const faq_title = {
  EN: "FAQ",
  PL: "Pytania do nas",
  SP: "Preguntas Frecuentes",
};
